<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [isShowModal]="false"
  [columns]="columns"
  (valueChangeWithName)="onvalueChangeWithName($event)"
  (valueChangeByApiName)="onValueChangeByApiName($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="formGroup">
    <ssg-tabset (tabChange)="selectTab($event)">
      <ssg-tab tabTitle="تنظیمات">
        <form-control-model class="setting-voucher-kind"
          [columns]="invDetailColumns"
          [group]="formGroup"
          [model]="model"
          [isShowModal]="false"
          (valueChangeWithName)="onvalueChangeWithName($event)"
          (valueChangeByApiName)="onValueChangeByApiName($event)">
        </form-control-model>
      </ssg-tab>

      <ssg-tab tabTitle="اطلاعات فروش" *ngIf="!model.IsWarehouse">
        <form-control-model [defaultHeight]="25" [columns]="sellColumns" [group]="formGroup" [model]="model"> </form-control-model>
      </ssg-tab>
      <ssg-tab tabTitle="ارتباط با راهکاران" *ngIf="sgColumns && sgColumns.length > 0">
        <form-control-model [defaultHeight]="25" [columns]="sgColumns" [group]="formGroup" [model]="model"> </form-control-model>
      </ssg-tab>
      <ssg-tab tabTitle="اسناد مبنا مجاز">
        <editable-grid
          *ngIf="isActveTab('اسناد مبنا مجاز')"
          [columns]="ReferenceVoucherKinds"
          [(dataList)]="model.ReferenceVoucherKinds"
          [DefaultValues]="DefaultValues">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="انواع تفصیلی">
        <editable-grid
          *ngIf="isActveTab('انواع تفصیلی')"
          [columns]="VoucherKindDetailLedgerKinds"
          [(dataList)]="model.VoucherKindDetailLedgerKinds"
          [DefaultValues]="DefaultValues">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="گروه کالا">
        <editable-grid
          *ngIf="isActveTab('گروه کالا')"
          [columns]="VoucherKindGoodss"
          [(dataList)]="model.VoucherKindGoodss"
          [DefaultValues]="DefaultValues"></editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
